import React from 'react';
import withAuthProvider, { AuthComponentProps } from '../Auth/AuthProvider';
import { resources } from '../resources.js';
import {
  Button, Table
} from 'reactstrap';
import Timetable from '../Components/Timetable';
import CalendarSync from '../Components/CalendarSync';
import { getTerm, sortTimetable } from '../Util/TimetableUtil';
import ErrorMessage from '../Util/ErrorMessage';

interface RostersState {
  hasTimetable: boolean,
  response: any,
  error: any,
  exportArr: any,
  timetableError: boolean
}

async function getTimetableDetails(accessToken: string, retry: number) {
  const bearer = 'Bearer ' + accessToken;

  console.log("Retries = " + retry);

  return fetch(
    resources.rosters.endpoint + getTerm().currentTerm, {
    method: 'GET',

    headers: {
      Authorization: bearer,
      'APIm-Debug': 'true',
    },
  }).then(res => {
    if (res.ok) return res.json()

    if (retry > 0) {
      getTimetableDetails(accessToken, retry - 1)
    } else {
      throw new Error(JSON.stringify(res))
    }

  })
    .catch(console.error)
}

class Rosters extends React.Component<AuthComponentProps, RostersState> {
  constructor(props: any) {
    super(props)
    this.state = {
      hasTimetable: false,
      response: { "student": {}, "sections": [] },
      error: null,
      exportArr: null,
      timetableError: false
    }
  }

  getExportArr = (exportArrFromTimetable: any) => {
    //get timetable export choices from here
    //console.log("Parent Array: " + exportArrFromTimetable);
    this.setState({
      exportArr: exportArrFromTimetable
    })
  }

  setErrorMessage(title: string, message: string, debug: string) {
    this.setState({
      error: { title: title, message: message, debug: debug }
    });
  }

  //Fetch Rosters API
  fetchData = async () => {
    if (this.props.user && !this.state.hasTimetable) {
      try {
        // Get the user's access token
        var accessToken = await this.props.getAccessToken(resources.rosters.scopes);

        // Get timetable from Rosters API
        var responseObject = await getTimetableDetails(accessToken, 3);

        // Handle undefined error here
        if (responseObject === 'undefined' || responseObject == null) {
          this.setErrorMessage("Unable to get your Timetable", "", "You are not currently registered in any classes for the current term.");
          this.setState({
            hasTimetable: false,
            response: responseObject,
            timetableError: true
          });
        }
        else {
          // Update the array of events in state
          this.setState({
            hasTimetable: true,
            response: responseObject,
            timetableError: false
          });
        };
      }
      catch (err) {
        this.setErrorMessage("Error fetching data", "", JSON.stringify(err));
      }
    }
  }

  //Fetch Local API
  // fetchData = () => {
  //   fetch('./timetable.json')
  //     .then((response) => response.json()) //JSON Object
  //     .then(data => {
  //       this.setState({
  //         response: data,
  //         hasTimetable: true
  //       });
  //     });
  // }

  componentDidUpdate() {
    if (!this.state.hasTimetable && !this.state.timetableError) {
      this.fetchData();
    }
  }

  render() {

    const timetableProps = {
      timetable: sortTimetable(this.state.response, "catalogCode"),
      hasTimetable: this.state.hasTimetable,
      getExportArr: this.getExportArr,
      exportedArray: this.state.exportArr
    }


    let error = null;
    if (this.state.error) {
      error = <ErrorMessage
        title={this.state.error.title}
        message={this.state.error.message}
        debug={this.state.error.debug}
      />;
    }

    return (
      <div>
        <h2 className="card-title">Your Timetable - {getTerm().currentTermDescr}</h2>
        <div className="highlight">Below select the classes, tutorials and labs that you wish to be copied into your Outlook Calendar. Press the 'Copy to Outlook Calendar' button below to copy.
          Mosaic is the primary source for all schedule information. Should times or locations conflict, your Mosaic class schedule is considered the system of authority.
          <ul>
            <li>Only classes in which you are enrolled will appear for export, any classes that have been cancelled/withdrawn will not appear.</li>
            <li>Changes in location/time will not be reflected in Outlook unless a new sync is performed.</li>
            <li>By default, all events will be copied. You can skip copying events using the toggle checkbox next to the event name.</li>
            <li>Any subsequent copies will overwrite ALL previous events.</li>
            <li>When submitting subsequent copies, include all of the courses you want to appear.</li>
            <li>If all classes have been dropped/cancelled, no classes will appear to sync and Outlook will need to be updated manually.</li>
          </ul>

          <div>
            Please reference the following table to determine when Timetables can be copied:
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th scope="col">Term</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Fall</td>
                  <td>September 1</td>
                  <td>December 31</td>
                </tr>
                <tr>
                  <td>Spring/Summer</td>
                  <td>May 1</td>
                  <td>August 31</td>
                </tr>
                <tr>
                  <td>Winter</td>
                  <td>January 1</td>
                  <td>April 30</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

        {/* <div><Button className="btn-primary" href="#" color="primary" role="button" onClick={this.fetchData}>API</Button></div> */}

        <div className="card-md">
          {this.state.hasTimetable && this.state.response !== undefined && !this.state.timetableError ?
            <Timetable {...timetableProps} />
            : <div>{error}</div>}
        </div>

        <section className="content-area white">
          <CalendarSync {...timetableProps} />
        </section>
      </div>
    );
  }
}

export default withAuthProvider(Rosters);




